/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  DocumentFolder,
  DocumentFolderFromJSON,
  DocumentFolderFromJSONTyped,
  DocumentFolderToJSON
} from './DocumentFolder'

/**
 *
 * @export
 * @interface GetDocumentFoldersResponseData
 */
export interface GetDocumentFoldersResponseData {
  /**
   *
   * @type {Array<DocumentFolder>}
   * @memberof GetDocumentFoldersResponseData
   */
  documentFolders?: Array<DocumentFolder>
}

export function GetDocumentFoldersResponseDataFromJSON(json: any): GetDocumentFoldersResponseData {
  return GetDocumentFoldersResponseDataFromJSONTyped(json, false)
}

export function GetDocumentFoldersResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetDocumentFoldersResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    documentFolders: !exists(json, 'document_folders')
      ? undefined
      : (json['document_folders'] as Array<any>).map(DocumentFolderFromJSON)
  }
}

export function GetDocumentFoldersResponseDataToJSON(value?: GetDocumentFoldersResponseData | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    document_folders:
      value.documentFolders === undefined ? undefined : (value.documentFolders as Array<any>).map(DocumentFolderToJSON)
  }
}
